/*
 * Copyright (c) 2022-2023. Haodong JU
 */

import IKDataEntity from '@/plugins/EntityFrameWork/IKDataEntity'
import hillo from 'hillo'

const entity = {
  name: {
    displayName: 'RechargeType'
  },
  amountToGet: {
    displayName: 'RechargeAmount'
  },
  amountToPay: {
    displayName: 'RechargePaymentAmount'
  }
}
const config = {
  load: async function () {
    return (await hillo.get('NfcCard.php?op=getNfcDepositMenuList', {
    })).content
  },
  add: async function (item) {
    return (await hillo.post('NfcCard.php?op=createNfcDepositMenu', {
      ...item
    })).content
  },
  edit: async function (item) {
    return (await hillo.post('NfcCard.php?op=updateNfcDepositMenu', {
      ...item
    })).content
  },
  remove: async function (id) {
    return (await hillo.post('NfcCard.php?op=deleteNfcDepositMenu', {
      id
    })).content
  }
}

export default IKDataEntity.ModelFactory(entity, config)

export async function memberRechargeFunc (item) {
  return (await hillo.post('Complex.php?op=fullDepositForCloudMember', {
    ...item
  })).content
}
